import { render, staticRenderFns } from "./OrderStep.vue?vue&type=template&id=27983b9a&scoped=true&"
import script from "./OrderStep.vue?vue&type=script&lang=js&"
export * from "./OrderStep.vue?vue&type=script&lang=js&"
import style0 from "./OrderStep.vue?vue&type=style&index=0&id=27983b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27983b9a",
  null
  
)

export default component.exports